import BarGraphic from './BarGraphic'
export default BarGraphic
